import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import type { DeleteAccount } from "@/Modules/Customers/Models/Domain";
import type { DeleteAccountApi } from "@/Modules/Customers/Models/Api";

import { deleteAccount } from "@/Services/TherapyApi/Customers";

import useCustomerStore from "@/Modules/Customers/Store";
import useAppStore from "@/Modules/App/Store";

import { snake } from "@/Utils/Snakelize";

async function deleteAccountAH(uuid: string, deleteData: DeleteAccount): Promise<boolean> {
  const appStore = useAppStore();
  const customerStore = useCustomerStore();

  try {
    const apiQuery = snake<DeleteAccount, DeleteAccountApi>(deleteData);

    await deleteAccount(uuid, apiQuery);

    appStore.showSnackbar({
      type: NotificationType.INFO,
      message: "account.delete_account.message_confirm_toast",
    });

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      type: NotificationType.ERROR,
    });

    return false;
  } finally {
    customerStore.isLoading = false;
  }
}

export default deleteAccountAH;
